export default {
  small: {
    toggle: {
      height: '20px',
      width: '20px',
    },
  },
  toggle: {
    border: {
      thickness: '0.125rem',
      style: 'solid',
    },
    margin: {
      left: '10px',
    },
    height: '1.875rem',
    width: '1.875rem',
  },
  icon: {
    width: '1.5625rem',
    height: '1.5625rem',
    close: {
      height: '1.125rem',
      width: '1.125rem',
    },
  },
  window: {
    border: {
      thickness: '0.125rem',
      style: 'solid',
    },
    padding: {
      top: '1.875rem',
      right: '1.875rem',
      bottom: '1.875rem',
      left: '1.875rem',
    },
    top: 'calc(100% + 1.25rem)',
    bottom: 'calc(100% + 1.25rem)',
    width: '15.625rem',
  },
  title: {
    fontSize: '1rem',
    lineHeight: '1.75rem',
    mobile: {
      lineHeight: '1.1',
    },
  },
  fontSize: '0.875rem',
  lineHeight: '1.55rem',
};
